export const MessageCount = ({ count }: any) => {
  return (
    <div className="flex flex-row justify-center items-center h-5 p-2 rounded-full box-border bg-[rgba(207,3,3,1)]">
      <p className="text-[#ffffff] text-xs text leading-3 font-inter font-[400]">{count}</p>
    </div>
  );
};
